import axios from 'axios';
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";

const SESSION_DEVAPP_WEB_ID = 'campaignDevAppWebId';
const SESSION_CAMPAIGNS_LIST = 'campaignsList';
const SESSION_CAMPAIGN = 'campaign';
//const SESSION_TAG = 'smsTag';
const BASE_URL = envService.getApiBaseUrl() + '/campaign-manager';

export const PLACEHOLDER_PREFIX = '${';
export const PLACEHOLDER_POSTFIX = '}';
export const PLACEHOLDER_PREFIX_UI = '[';
export const PLACEHOLDER_POSTFIX_UI = ']';

export default {
    setCampaignWebId(webId) {
        logger.debug("webId=" + webId);
        sessionStorage.setItem(SESSION_DEVAPP_WEB_ID, webId);
    },

    getCampaignWebId() {
        return sessionStorage.getItem(SESSION_DEVAPP_WEB_ID);
    },

    setCampaignToSession(campaign) {
        logger.debug("campaign=" + JSON.stringify(campaign));
        sessionStorage.setItem(SESSION_CAMPAIGN, JSON.stringify(campaign));
    },

    getCampaignFromSession() {
        return JSON.parse(sessionStorage.getItem(SESSION_CAMPAIGN));
    },

    /* TODO tag must be save in campaign object
    setTagToSession(tag) {
        sessionStorage.setItem(SESSION_TAG, JSON.stringify(tag))
    },

    getTagFromSession() {
        return JSON.parse(sessionStorage.getItem(SESSION_TAG));
    },
*/
    async reloadCampaignInSession() {
        let campaignInSession = this.getCampaignFromSession();
        if (campaignInSession !== null) {
            let response = await this.getCampaign(this.getCampaignWebId(), campaignInSession.id)
            this.setCampaignToSession(response.data)
        }
    },

    getCampaignId() {
        const campaign = this.getCampaignFromSession();
        if (campaign !== null) {
            return campaign.id;

        }
        return "Campaign is undefined";
    },

    getCampaignName() {
        const campaign = this.getCampaignFromSession();
        if (campaign !== null) {
            return campaign.name;
        }
        return "Campaign is undefined";
    },

    getCampaignStatus() {
        const campaign = this.getCampaignFromSession();
        if (campaign !== null) {
            return campaign.status;
        }
        return "Campaign is undefined";
    },

    getDevAppCampaign(email) {
        return axios.get(BASE_URL + '/dev-apps-campaign', {
            headers: {
                'X-User-Email': email,
            },
        });
    },

    getCampaignsList(webId) {
        return axios.get(BASE_URL,
            {
                headers: {
                    'webid': webId,
                },
            });
    },

    getCampaign(webId, campaignId) {
        return axios.get(BASE_URL + '/' + campaignId,
            {
                headers: {
                    'webid': webId,
                },
            });
    },

    updateCampaignText(webId, campaignId, campaignName, placeholder4PhoneNumber, campaignText) {
        return axios.put(BASE_URL + '/' + campaignId,
            {
                "name": campaignName,
                "template": campaignText,
                "placeholder4PhoneNumber": placeholder4PhoneNumber
            },
            {
                headers: {
                    'webid': webId,
                },
            }
        );
    },

    createCampaign(webid, campaignName, csvFiles) {
        const formdata = new FormData()
        formdata.append('csvFile', csvFiles[0])
        formdata.append('campaignName', campaignName)

        return axios.post(BASE_URL, formdata,
            {
                headers: {
                    'webid': webid,
                    'Content-Type': 'multipart/form-data',
                },
            });
    },


    updateCampaignCsv(webid, campaignId, campaignName, csvFiles) {
        const formdata = new FormData()
        formdata.append('csvFile', csvFiles[0])
        formdata.append('campaignName', campaignName)

        return axios.put(BASE_URL + '/' + campaignId + '/csv', formdata,
            {
                headers: {
                    'webid': webid,
                    'Content-Type': 'multipart/form-data',
                    'Content-Encoding': 'gzip'
                },
            });
    },

    setCampaignsListToSession(data) {
        sessionStorage.setItem(SESSION_CAMPAIGNS_LIST, JSON.stringify(data));
    },

    getCampaignsListFromSession() {
        return JSON.parse(sessionStorage.getItem(SESSION_CAMPAIGNS_LIST));
    },

    removeCampaignsList() {
        sessionStorage.removeItem(SESSION_CAMPAIGNS_LIST);
    },

    getPlaceholders(webid, campaignId) {
        return axios.get(BASE_URL + '/' + campaignId + '/placeholders', {
            headers: {
                'webid': webid,
            },
        });
    },

    getPreview(webId, campaignId, count) {
        return axios.get(BASE_URL + '/' + campaignId + '/preview?count=' + count, {
            headers: {
                'webId': webId,
            },
        });
    },

// TODO do not pass email as header -> query parameter
// TODO only submit query parameter if current user is admin -> userService.getUser().admin === true
    getPrice(webId, campaignId) {
        return axios.get(BASE_URL + '/' + campaignId + '/price', {
            headers: {
                'webId': webId,
            },
        });
    },

    putCampaignStatus(webId, campaignId) {
        return axios.put(BASE_URL + '/' + campaignId + '/status', null, {
            headers: {
                'webId': webId
            },
        });
    },

    deleteCampaign(webId, campaignId) {
        return axios.delete(BASE_URL + '/' + campaignId,
            {
                headers: {
                    'webId': webId,
                },
            }
        );
    },

    cloneCampaign(webId, campaignId) {
        return axios.post(BASE_URL + '/' + campaignId + '/clone',
            {},
            {
                headers: {
                    'webId': webId,
                },
            }
        );
    },

    getCampaignsConfig() {
        return axios.get(BASE_URL + '/config');
    },
}


